import axios from 'axios';
import { getSessionItem, KEYS } from '../store/storage';
import { handleAuthorData, logout } from '../actions/user';
import { API_PREFIX, CLIENT_ID } from '../consts';
import { IDENTITY_ADMIN } from '../consts/user';
import { AUTH_CLIENT_ID } from '../consts/third_party';

const refreshTokenInterval = 5 * 1000;
let retryCount = 3;

class RefreshTokenClient {
  constructor() {
    this.refreshTokenPromise = null;
    this.client = axios.create();
  }

  async _refreshTokenHandle() {
    const refreshToken = getSessionItem(KEYS.refreshToken);
    const identity = getSessionItem(KEYS.identity);
    let response;

    try {
      response = await this.client.request({
        url: `${API_PREFIX}/v1/login/refresh`,
        method: 'POST',
        data: {
          refresh_token: refreshToken,
          grant_type: 'refresh_token',
          client_id: identity === IDENTITY_ADMIN ? AUTH_CLIENT_ID : CLIENT_ID,
        },
        noNeedLogin: true,
      });
      return Promise.resolve(response.data);
    } catch (e) {
      return Promise.reject('Refresh token failed');
    }
  }

  async _getRefreshToken() {
    try {
      return this._refreshTokenHandle();
    } catch (e) {
      retryCount -= 1;
      if (retryCount > 1) {
        return this._getRefreshToken();
      }
    }
  }

  _getRefreshUserTokenPromise() {
    if (!this.refreshTokenPromise) {
      retryCount = 3;
      this.refreshTokenPromise = this._getRefreshToken();
    }

    return this.refreshTokenPromise;
  }

  async refreshTokenAfter401(store) {
    try {
      const userInfo = await this._getRefreshUserTokenPromise();
      handleAuthorData(userInfo);
      setTimeout(() => {
        this.refreshTokenPromise = null;
      }, refreshTokenInterval);
      return Promise.resolve(userInfo);
    } catch (e) {
      store.dispatch(logout());
      return Promise.reject('Refresh token failed');
    }
  }

  async beforeRequest(store) {
    const token = getSessionItem(KEYS.token);
    if (!token) {
      store.dispatch(logout());
      return Promise.reject(new Error('Token expired'));
    }

    const expireTime = getSessionItem(KEYS.expireTime, 0);
    if (expireTime > new Date().getTime()) {
      return Promise.resolve();
    }

    return await this.refreshTokenAfter401(store);
  }
}

export const refreshTokenClient = new RefreshTokenClient();
